import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { SettingsService } from '../foundation/settings/settings.service';

@Pipe({
  name: 'curr',
})
export class CurrencyValuePipe extends CurrencyPipe implements PipeTransform {
  constructor(private settingsService: SettingsService) {
    super(settingsService.getLocaleId());
  }

  override transform(value: any, arg?: string): any {
    let result: string | null = '';
    if (typeof value === 'number') {
      if (value % 1 != 0 || arg === 'doubleDecimalPlace') {
        result = super.transform(value, 'CHF', 'code', '1.2-2', 'en');
        result = [result?.slice(0, 3), ' ', result?.slice(3)].join('');
        result = result.replace(',', "'");
      } else {
        result = super.transform(value, 'CHF', 'code', '1.0-0', 'en');
        result = [result?.slice(0, 3), ' ', result?.slice(3)].join('');
        result = result.replace(',', "'");
      }

      if (value > 1000000) {
        result = super.transform(value / 1000000, 'CHF', 'code', '1.0-0', 'en');
        result = [result?.slice(0, 3), ' ', result?.slice(3)].join('');
        result += ' Mio.';
      }
    } else {
      return value;
    }

    return result;
  }
}
